export class Alert {
    id: string;
    type: AlertType;
    message: string;
    autoClose: boolean;
    keepAfterRouteChange: boolean;
    fade: boolean;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }
}

export class AlertOptions {
    autoClose?: boolean; // Default is false
    fade?: boolean; // Default is true
    replace?: boolean; // Default is false. In this case, the previous alert is replaced.
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning,
    LoginError
}
